import { IhsSamAuthorityEnvCode, IpreoAccountAuthorityEnvCode, OktaAuthorityEnvCode } from '../app/authorization/contracts/auth-client-settings';
import { Environment as ExternalParticipantsEnvironment } from '@ipreo/bd-external-participants';
import { Environment as CompanyContactsEnvironment } from '@ipreo/company-contacts-modal';

// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  envName: 'staging',
  baseUrl: 'https://api.staging.bdc.ipreo.com/activity',
  hubBaseUrl: 'https://staging.event-hub.ipreo.com',
  domain: 'https://bdcorporate.demo.ipreo.com',
  ipreoAccount: {
    authority: IpreoAccountAuthorityEnvCode.Staging,
    clientId: 'billfold-demo'
  },
  ihsSam: {
    clientId: 'issuersolutions-capitalaccess-eventmanagement-dev-640GPrhe18',
    authority: IhsSamAuthorityEnvCode.Staging,
  },
  okta: {
    clientId: 'issuersolutions-capitalaccess-eventmanagement-dev-640gprhe18',
    authority: OktaAuthorityEnvCode.Staging,
  },
  externalParticipantEnvironment: ExternalParticipantsEnvironment.Demo,
  companyContactsEnvironment: CompanyContactsEnvironment.Staging,
  baseRedirectionPath: '/activity/',
  googleApiKey: 'AIzaSyBbREFaNM9NiIlClDXcSHm9ICaSEXSpt70'
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
